import axios from 'axios';
import config from '../config/env.config';

const API_BASE_URL = config.API_URL;

// Create axios instance for public endpoints (no authentication required)
const publicApi = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for debugging
publicApi.interceptors.request.use(
  (config) => {
    console.log('Public API Request:', config.method?.toUpperCase(), config.url);
    console.log('Full URL:', config.baseURL + config.url);
    return config;
  },
  (error) => {
    console.error('Public API Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging
publicApi.interceptors.response.use(
  (response) => {
    console.log('Public API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('Public API Response Error:', error.response?.status, error.config?.url);
    console.error('Error details:', error.response?.data);
    return Promise.reject(error);
  }
);

// No request interceptors - this is for public endpoints
// No response interceptors - this is for public endpoints

export default publicApi; 